import React, { MouseEvent } from 'react';

import { MDText } from 'i18n-react';

import { Button } from '@motorway/mw-highway-code';

import Theme from '../../../components/legacy/theme/Theme';
import Texts from '../../../texts.json';

import Error from './Error';

const LocalT = new MDText(Texts);

interface Error500Props {
  showSign?: boolean;
  testid?: string;
}

const reloadHandler = (e: MouseEvent<HTMLAnchorElement>) => {
  e.preventDefault();
  window.location.reload();
};

const Error500: React.FC<Error500Props> = ({ showSign = true, testid = '500' }) => (
  <Theme>
    <Error
      buttonLabel="500.buttonLabel"
      buttonProps={{
        element: () => (
          <Button
            fullWidth
            as={'a'}
            href={'/'}
            icon="chevron"
            label={LocalT.translate('500.buttonLabel')}
            onClick={reloadHandler}
          />
        ),
        to: '',
      }}
      detail={LocalT.translate('500.detail', {
        contact: (
          <a href="https://help.motorway.co.uk/hc/en-gb/p/contact">
            {LocalT.translate('500.contactUs')}
          </a>
        ),
      })}
      number="500"
      title="500.title"
      { ...{ showSign, testid }}
    />
  </Theme>
);

export default Error500;
